import { createCollection } from '@tanstack/db';
import { queryCollectionOptions } from '@tanstack/query-db-collection';

import { getOthHoofdstukReservering } from '@/api/generated/digiVAPI';
import { queryClient } from '@/services/queryClient';
import { fetchAllPages } from '@/utils/fetchAllPages';

type HoofdstukReserveringCollection = ReturnType<
  typeof createHoofdstukReserveringCollection
>;
type HoofdstukReserveringCollections = Record<
  string,
  HoofdstukReserveringCollection
>;

export const HOOFDSTUK_RESERVERING_COLLECTION_QUERY_KEY = [
  'hoofdstuk-reservering-collection',
] as const;

const hoofdstukReserveringCollections: HoofdstukReserveringCollections = {};

export const getHoofdstukReserveringCollection = ({
  besluitLineageId,
}: {
  besluitLineageId: string;
}) => {
  const collection = hoofdstukReserveringCollections[besluitLineageId];

  if (collection) return collection;

  const newCollection = createHoofdstukReserveringCollection({
    besluitLineageId,
  });

  hoofdstukReserveringCollections[besluitLineageId] = newCollection;

  return newCollection;
};

const createHoofdstukReserveringCollection = ({
  besluitLineageId,
}: {
  besluitLineageId: string;
}) => {
  return createCollection(
    queryCollectionOptions({
      id: `hoofdstuk-reservering-collection-${besluitLineageId}`,
      queryClient,
      queryKey: [
        ...HOOFDSTUK_RESERVERING_COLLECTION_QUERY_KEY,
        besluitLineageId,
      ],
      getKey: (item) => item.ID,
      queryFn: async () => {
        const response = await fetchAllPages((page) =>
          getOthHoofdstukReservering({
            page,
            size: 100,
            filter: [
              {
                model: 'HoofdstukLineage',
                field: 'Besluit_lineage',
                op: 'eq',
                value: besluitLineageId,
              },
            ],
          })
        );

        return response;
      },
    })
  );
};
